export const primary = "#2BC2D3";
export const secondary = "#51626A";
export const blue = "#5F7B9A";
export const white = "#FFF";
export const grey = "#D4DFE3";
export const black = "#57606F";
